export default __webpack_public_path__ + "static/media/at.5b093322.svg";